/**
 * Access level to resources/pages
 * Hierarchy: None < Read < Write
 */
export enum AccessType {
  None = 'None',
  Read = 'Read',
  Write = 'Write'
}

/**
 * Checks if given access level meets the required minimum level
 * @param actualAccess - user's actual access level
 * @param requiredAccess - required minimum access level
 * @returns true if actualAccess >= requiredAccess in hierarchy
 */
export function meetsAccessRequirement(
  actualAccess: AccessType,
  requiredAccess: AccessType
): boolean {
  const hierarchy = {
    [AccessType.None]: 0,
    [AccessType.Read]: 1,
    [AccessType.Write]: 2
  };

  return hierarchy[actualAccess] >= hierarchy[requiredAccess];
}

/**
 * Selects the higher access level from two given levels
 */
export function maxAccess(a: AccessType, b: AccessType): AccessType {
  const hierarchy = {
    [AccessType.None]: 0,
    [AccessType.Read]: 1,
    [AccessType.Write]: 2
  };

  return hierarchy[a] >= hierarchy[b] ? a : b;
}
